import React from "react";
import "./WhatsAppChat.scss";

const WhatsAppChat = () => {
  const handleWhatsAppClick = () => {
    const whatsappLink = `https://wa.me/5492914045000?text=Hola,%20me%20gustaría%20consultar%20sobre%20sus%20productos`;
    // const whatsappLink = `https://wa.me/5492915087317?text=Hola,%20me%20gustaría%20consultar%20sobre%20sus%20productos`;
    window.open(whatsappLink, "_blank");
  };

  return (
    <div>
      <button
        onClick={handleWhatsAppClick}
        className="whatsapp-button"
        title="Consultanos"
      >
        <i className="fa fa-whatsapp"></i>
      </button>
    </div>
  );
};

export default WhatsAppChat;
